//@author: devin

import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { S25LynxComponent } from "./s25.lynx.component";
import { S25ToggleButtonModule } from "../s25-toggle-button/s25.toggle.button.module";
import { S25LynxHomeComponent } from "./s25-lynx-home/s25.lynx.home.component";
import { S25LynxStatusComponent } from "./s25-lynx-status/s25.lynx.status.component";

@NgModule({
    declarations: [S25LynxComponent, S25LynxHomeComponent],
    imports: [CommonModule, S25ToggleButtonModule, S25LynxStatusComponent],
    exports: [S25LynxComponent, S25LynxHomeComponent],
    providers: [S25LynxComponent, S25LynxHomeComponent],
})
export class S25LynxModule {
    constructor() {}
}
